import Vue from "vue";

import AppNotFoundGoodsForm from "@/AppNotFoundGoodsForm";
import AppCorm from "@/AppCorpForm";
import AppRemindCallForm from "@/AppRemindCallForm";
import AppAskQuestionForm from "@/AppAskQuestionForm.vue";
import AppOrderGoodsForm from "@/AppOrderGoodsForm";
import AppLeaveCompliantForm from "@/AppLeaveCompliantForm";
import AppCalcForm from "@/AppCalcForm";
import AppCorpProduct from "@/AppCorpProduct";

import "./assets/style.scss";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(AppNotFoundGoodsForm),
}).$mount("#app");

new Vue({
  render: (h) => h(AppCorm),
}).$mount("#app2");

new Vue({
  render: (h) => h(AppCorm),
}).$mount("#app2-2");

new Vue({
  render: (h) => h(AppRemindCallForm),
}).$mount("#app3");

new Vue({
  render: (h) => h(AppAskQuestionForm),
}).$mount("#app4");

new Vue({
  render: (h) => h(AppOrderGoodsForm),
}).$mount("#app5");

new Vue({
  render: (h) => h(AppLeaveCompliantForm),
}).$mount("#app6");

new Vue({
  render: (h) => h(AppCalcForm),
}).$mount("#app7");

new Vue({
  render: (h) => h(AppCorpProduct),
}).$mount("#app8");

// new Vue({
//   render: (h) => h(App),
// }).$mount("#app-2");
